<template>
  <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('dashboard.behavior-audit.duplicated-comment')" name="1">
        <el-table
          :data="data.comment.duplicated.detail"
          style="width: 100%">
          <el-table-column
            prop="comment"
            :label="$t('dashboard.behavior-audit.comment')"
            width="200">
          </el-table-column>
          <el-table-column
            prop="num"
            width="100"
            :label="$t('dashboard.behavior-audit.num')">
          </el-table-column>
          <el-table-column
            prop="candidate"
            width="600"
            :label="$t('dashboard.behavior-audit.candidate')">
            <template slot-scope="scope">
              <div v-for="c in scope.row.people">
                <el-link type="info" :href="url + c.id" target="_blank">
                  {{ c.name }} @ {{ c.title }} of {{ c.company }} Operating Time: {{ c.time }}
                </el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('dashboard.behavior-audit.short-comment')" name="2">
        <el-table
          :data="data.comment.short.detail"
          style="width: 100%">
          <el-table-column
            prop="comment"
            :label="$t('dashboard.behavior-audit.comment')"
            width="200">
          </el-table-column>
          <el-table-column
            prop="time"
            width="150"
            :label="$t('dashboard.behavior-audit.time')">
          </el-table-column>
          <el-table-column
            prop="candidate"
            width="600"
            :label="$t('dashboard.behavior-audit.candidate')">
            <template slot-scope="scope">
              <el-link type="info" :href="url + scope.row.people.id" target="_blank">
                {{ scope.row.people.name }} @ {{ scope.row.people.title }} of {{ scope.row.people.company }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('dashboard.behavior-audit.comment-interval')" name="3">
        <el-table
          :data="data.comment.interval.detail"
          style="width: 100%">
          <el-table-column
            prop="comment"
            :label="$t('dashboard.behavior-audit.comment')"
            width="300">
          </el-table-column>
          <el-table-column
            prop="time"
            width="150"
            :label="$t('dashboard.behavior-audit.time')">
          </el-table-column>
          <el-table-column
            prop="interval"
            width="80"
            :label="$t('dashboard.behavior-audit.interval')">
          </el-table-column>
          <el-table-column
            prop="candidate"
            width="600"
            :label="$t('dashboard.behavior-audit.candidate')">
            <template slot-scope="scope">
              <el-link type="info" :href="url + scope.row.people.id" target="_blank">
                {{ scope.row.people.name }} @ {{ scope.row.people.title }} of {{ scope.row.people.company }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('dashboard.behavior-audit.duplicated-lr')" name="4">
        <el-table
          :data="data.leaveReason.duplicated.detail"
          style="width: 100%">
          <el-table-column
            prop="leaveReason"
            :label="$t('dashboard.behavior-audit.lr')"
            width="200">
          </el-table-column>
          <el-table-column
            prop="num"
            width="100"
            :label="$t('dashboard.behavior-audit.num')">
          </el-table-column>
          <el-table-column
            prop="candidate"
            width="600"
            :label="$t('dashboard.behavior-audit.candidate')">
            <template slot-scope="scope">
              <div v-for="c in scope.row.people">
                <el-link type="info" :href="url + c.id" target="_blank">
                  {{ c.name }} @ {{ c.title }} of {{ c.company }}
                </el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('dashboard.behavior-audit.short-lr')" name="5">
        <el-table
          :data="data.leaveReason.short.detail"
          style="width: 100%">
          <el-table-column
            prop="leaveReason"
            :label="$t('dashboard.behavior-audit.lr')"
            width="200">
          </el-table-column>
          <el-table-column
            prop="time"
            width="150"
            :label="$t('dashboard.behavior-audit.time')">
          </el-table-column>
          <el-table-column
            prop="candidate"
            width="600"
            :label="$t('dashboard.behavior-audit.candidate')">
            <template slot-scope="scope">
              <el-link type="info" :href="url + scope.row.people.id" target="_blank">
                {{ scope.row.people.name }} @ {{ scope.row.people.title }} of {{ scope.row.people.company }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('dashboard.behavior-audit.duplicated-salary')" name="6">
        <el-table
          :data="data.salaryDetail.duplicated.detail"
          style="width: 100%">
          <el-table-column
            prop="salaryDetail"
            :label="$t('dashboard.behavior-audit.salary')"
            width="200">
          </el-table-column>
          <el-table-column
            prop="num"
            width="100"
            :label="$t('dashboard.behavior-audit.num')">
          </el-table-column>
          <el-table-column
            prop="candidate"
            width="600"
            :label="$t('dashboard.behavior-audit.candidate')">
            <template slot-scope="scope">
              <div v-for="c in scope.row.people">
                <el-link type="info" :href="url + c.id" target="_blank">
                  {{ c.name }} @ {{ c.title }} of {{ c.company }}
                </el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('dashboard.behavior-audit.short-salary')" name="7">
        <el-table
          :data="data.salaryDetail.short.detail"
          style="width: 100%">
          <el-table-column
            prop="salaryDetail"
            :label="$t('dashboard.behavior-audit.salary')"
            width="200">
          </el-table-column>
          <el-table-column
            prop="time"
            width="150"
            :label="$t('dashboard.behavior-audit.time')">
          </el-table-column>
          <el-table-column
            prop="candidate"
            width="600"
            :label="$t('dashboard.behavior-audit.candidate')">
            <template slot-scope="scope">
              <el-link type="info" :href="url + scope.row.people.id" target="_blank">
                {{ scope.row.people.name }} @ {{ scope.row.people.title }} of {{ scope.row.people.company }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
  </el-tabs>
</template>
<script>
import moment from 'moment'

export default {
  name: 'Audit-Detail',
  props: ['data'],
  computed: {
    url: function() {
      return this.STARLINKS_URL + 'people/'
    }
  },
  data () {
    return {
      activeName: '1'
    }
  },
  methods: {
    
  },
  created: function() {
  }
}
</script>